document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initComparadores();
  initGaleriaProducto();
  initVariantesProducto();
  initCantidadProducto();
  initBotonContrareembolso();
  initBotonTarjeta();
  initZoomProducto();
  initResenasCarrusel();
  initStickyCompra();
  initContadorOferta();
  initHeroPremiumTilt();
  initUrgenciaStock();
});

function initUrgenciaStock() {
  document.querySelectorAll('[data-mt-urgencia-texto]').forEach(function (el) {
    var plantilla = el.getAttribute('data-plantilla') || el.textContent;
    var stock = Math.floor(Math.random() * 6) + 5; // 5 a 10
    el.textContent = plantilla.replace('{stock}', stock);
  });
}

function initHeroPremiumTilt() {
  var wrap = document.querySelector('.mt-producto__hero-premium-media');
  var img = wrap ? wrap.querySelector('img') : null;
  if (!wrap || !img) return;
  var puedeHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var movimientoReducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!puedeHover || movimientoReducido) return;

  var raf = null;
  wrap.addEventListener('mousemove', function (e) {
    var rect = wrap.getBoundingClientRect();
    var px = (e.clientX - rect.left) / rect.width - 0.5;
    var py = (e.clientY - rect.top) / rect.height - 0.5;
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      img.style.transform = 'rotateX(' + (-py * 12).toFixed(2) + 'deg) rotateY(' + (px * 12).toFixed(2) + 'deg)';
    });
  });
  wrap.addEventListener('mouseleave', function () {
    if (raf) cancelAnimationFrame(raf);
    img.style.transform = '';
  });
}

function initContadorOferta() {
  document.querySelectorAll('[data-mt-contador]').forEach(function (contador) {
    var reloj = contador.querySelector('[data-mt-contador-reloj]');
    if (!reloj) return;
    var horas = parseFloat(contador.getAttribute('data-duracion-horas')) || 4;
    var duracionMs = horas * 60 * 60 * 1000;
    var storageKey = 'mt_contador_fin';
    var fin;
    try {
      var guardado = window.localStorage.getItem(storageKey);
      fin = guardado ? parseInt(guardado, 10) : 0;
      if (!fin || fin <= Date.now()) {
        fin = Date.now() + duracionMs;
        window.localStorage.setItem(storageKey, String(fin));
      }
    } catch (e) {
      fin = Date.now() + duracionMs;
    }

    function pad(n) { return String(n).padStart(2, '0'); }

    function actualizar() {
      var restante = fin - Date.now();
      if (restante <= 0) {
        try { window.localStorage.removeItem(storageKey); } catch (e) {}
        fin = Date.now() + duracionMs;
        try { window.localStorage.setItem(storageKey, String(fin)); } catch (e) {}
        restante = fin - Date.now();
      }
      var h = Math.floor(restante / 3600000);
      var m = Math.floor((restante % 3600000) / 60000);
      var s = Math.floor((restante % 60000) / 1000);
      reloj.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    }

    actualizar();
    setInterval(actualizar, 1000);
  });
}

function initStickyCompra() {
  var sticky = document.querySelector('[data-mt-sticky-compra]');
  var trigger = document.querySelector('.mt-producto__btn-comprar');
  if (!sticky || !trigger) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      sticky.hidden = entry.isIntersecting;
    });
  }, { rootMargin: '-10% 0px 0px 0px' });

  observer.observe(trigger);
}

function initResenasCarrusel() {
  document.querySelectorAll('[data-mt-resenas-carrusel]').forEach(function (carrusel) {
    var track = carrusel.querySelector('[data-mt-resenas-track]');
    var prevBtn = carrusel.querySelector('[data-mt-resenas-prev]');
    var nextBtn = carrusel.querySelector('[data-mt-resenas-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function pasoScroll() {
      var tarjeta = track.querySelector('.mt-resena-card');
      if (!tarjeta) return track.clientWidth;
      var estilo = getComputedStyle(track);
      var gap = parseFloat(estilo.columnGap || estilo.gap || 0);
      return tarjeta.getBoundingClientRect().width + gap;
    }

    function actualizarBotones() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -pasoScroll(), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: pasoScroll(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', actualizarBotones, { passive: true });
    window.addEventListener('resize', actualizarBotones);
    actualizarBotones();
  });
}

function initZoomProducto() {
  var galerias = document.querySelectorAll('.mt-producto__galeria');
  galerias.forEach(function (galeria) {
    var modal = galeria.parentElement.querySelector('[data-mt-zoom-modal]');
    var abrirBtn = galeria.querySelector('[data-mt-zoom-abrir]');
    if (!modal || !abrirBtn) return;

    var zoomImg = modal.querySelector('[data-mt-zoom-img]');
    var miniaturas = Array.prototype.slice.call(galeria.querySelectorAll('.mt-producto__miniatura'));
    var principalImg = galeria.querySelector('.mt-producto__principal img');

    function listaImagenes() {
      if (miniaturas.length) {
        return miniaturas.map(function (m) { return { full: m.getAttribute('data-full'), alt: m.querySelector('img').alt }; });
      }
      return [{ full: principalImg.src, alt: principalImg.alt }];
    }

    var indice = 0;

    function abrirEn(i) {
      var imgs = listaImagenes();
      indice = (i + imgs.length) % imgs.length;
      zoomImg.src = imgs[indice].full;
      zoomImg.alt = imgs[indice].alt || '';
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function indiceActual() {
      var activa = galeria.querySelector('.mt-producto__miniatura.is-activa');
      if (!activa) return 0;
      return miniaturas.indexOf(activa);
    }

    abrirBtn.addEventListener('click', function () { abrirEn(indiceActual()); });
    abrirBtn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); abrirEn(indiceActual()); }
    });

    modal.querySelector('[data-mt-zoom-cerrar]').addEventListener('click', cerrar);
    modal.addEventListener('click', function (e) { if (e.target === modal) cerrar(); });
    modal.querySelector('[data-mt-zoom-prev]').addEventListener('click', function () { abrirEn(indice - 1); });
    modal.querySelector('[data-mt-zoom-next]').addEventListener('click', function () { abrirEn(indice + 1); });

    function cerrar() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') cerrar();
      if (e.key === 'ArrowLeft') abrirEn(indice - 1);
      if (e.key === 'ArrowRight') abrirEn(indice + 1);
    });
  });
}

function initBotonContrareembolso() {
  document.querySelectorAll('[data-mt-cod-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var trigger = document.getElementById('es-sticky') || document.getElementById('es-form-button');
      if (trigger) {
        trigger.click();
      }
    });
  });
}

function initBotonTarjeta() {
  document.querySelectorAll('[data-mt-tarjeta-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = btn.closest('[data-mt-producto-form]');
      if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      var cantidadInput = form.querySelector('.mt-producto__cantidad input');
      if (!idInput || !idInput.value) return;

      var textoOriginal = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<span>Redirigiendo…</span>';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: idInput.value, quantity: parseInt((cantidadInput && cantidadInput.value) || '1', 10) }]
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('No se pudo añadir al carrito');
          window.location.href = '/checkout';
        })
        .catch(function () {
          btn.disabled = false;
          btn.innerHTML = textoOriginal;
        });
    });
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el, i) {
    el.style.setProperty('--mt-delay', Math.min(i * 0.08, 0.4) + 's');
    observer.observe(el);
  });
}

function initComparadores() {
  var frames = document.querySelectorAll('.mt-comparador__frame');
  frames.forEach(function (frame) {
    var afterWrap = frame.querySelector('.mt-comparador__after-wrap');
    var afterImg = frame.querySelector('.mt-comparador__after-wrap img');
    var handle = frame.querySelector('.mt-comparador__handle');
    if (!afterWrap || !handle) return;

    function setWidth(px) {
      var rect = frame.getBoundingClientRect();
      var ratio = Math.max(0, Math.min(1, px / rect.width));
      afterWrap.style.width = (ratio * 100) + '%';
      handle.style.left = (ratio * 100) + '%';
      if (afterImg) afterImg.style.width = rect.width + 'px';
    }

    function fromEvent(clientX) {
      var rect = frame.getBoundingClientRect();
      setWidth(clientX - rect.left);
    }

    var dragging = false;
    frame.addEventListener('mousedown', function (e) { dragging = true; fromEvent(e.clientX); });
    window.addEventListener('mouseup', function () { dragging = false; });
    window.addEventListener('mousemove', function (e) { if (dragging) fromEvent(e.clientX); });
    frame.addEventListener('touchstart', function (e) { dragging = true; fromEvent(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('touchend', function () { dragging = false; });
    window.addEventListener('touchmove', function (e) { if (dragging) fromEvent(e.touches[0].clientX); }, { passive: true });
    frame.addEventListener('click', function (e) { fromEvent(e.clientX); });

    window.addEventListener('resize', function () { setWidth(frame.getBoundingClientRect().width / 2); });
    setWidth(frame.getBoundingClientRect().width / 2);
  });
}

function initGaleriaProducto() {
  var galerias = document.querySelectorAll('.mt-producto__galeria');
  galerias.forEach(function (galeria) {
    var principalImg = galeria.querySelector('.mt-producto__principal img');
    var minis = galeria.querySelectorAll('.mt-producto__miniatura');
    if (!principalImg || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-full') || mini.querySelector('img').src;
        principalImg.src = src;
        principalImg.alt = mini.querySelector('img').alt || '';
        minis.forEach(function (m) { m.classList.remove('is-activa'); });
        mini.classList.add('is-activa');
      });
    });
  });
}

function initVariantesProducto() {
  var forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var pillGroups = form.querySelectorAll('[data-mt-opcion]');
    var idInput = form.querySelector('input[name="id"]');
    var precioEl = form.closest('.mt-producto__col-compra') ? form.closest('.mt-producto__col-compra').querySelector('.mt-producto__precio') : null;
    var precioAntesEl = form.closest('.mt-producto__col-compra') ? form.closest('.mt-producto__col-compra').querySelector('.mt-producto__precio-antes') : null;
    var btn = form.querySelector('.mt-producto__btn-comprar');
    var disponibilidadEl = form.closest('.mt-producto__col-compra') ? form.closest('.mt-producto__col-compra').querySelector('.mt-producto__disponibilidad') : null;

    function opcionesSeleccionadas() {
      var seleccion = [];
      pillGroups.forEach(function (group) {
        var activo = group.querySelector('.is-activa');
        seleccion.push(activo ? activo.getAttribute('data-valor') : null);
      });
      return seleccion;
    }

    function encontrarVariante() {
      var seleccion = opcionesSeleccionadas();
      return variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
    }

    function cambiarFoto(variante) {
      if (!variante || !variante.imagen) return;
      var principal = document.querySelector('.mt-producto__principal img');
      if (!principal) return;
      var clave = variante.imagen.split('?')[0].split('/').pop();
      var minis = document.querySelectorAll('.mt-producto__miniatura');
      minis.forEach(function (m) {
        if ((m.getAttribute('data-full') || '').split('?')[0].split('/').pop() === clave) m.click();
      });
    }

    function actualizar(cambiarImagen) {
      var variante = encontrarVariante();
      if (!variante) return;
      if (cambiarImagen === true) cambiarFoto(variante);
      idInput.value = variante.id;
      if (precioEl) precioEl.textContent = formatoDinero(variante.price);
      if (precioAntesEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAntesEl.textContent = formatoDinero(variante.compare_at_price);
          precioAntesEl.style.display = '';
        } else {
          precioAntesEl.style.display = 'none';
        }
      }
      if (btn) btn.disabled = !variante.available;
      if (disponibilidadEl) {
        if (variante.available) {
          disponibilidadEl.textContent = disponibilidadEl.getAttribute('data-texto-disponible') || 'En stock';
          disponibilidadEl.className = 'mt-producto__disponibilidad disponible';
        } else {
          disponibilidadEl.textContent = disponibilidadEl.getAttribute('data-texto-agotado') || 'Agotado';
          disponibilidadEl.className = 'mt-producto__disponibilidad agotado';
        }
      }
    }

    pillGroups.forEach(function (group) {
      group.querySelectorAll('.mt-producto__pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('.mt-producto__pill').forEach(function (p) { p.classList.remove('is-activa'); });
          pill.classList.add('is-activa');
          actualizar(true);
        });
      });
    });

    var inicial = form.getAttribute('data-valor-inicial');
    if (inicial && location.search.indexOf('variant=') === -1) {
      pillGroups.forEach(function (group) {
        var objetivo = group.querySelector('.mt-producto__pill[data-valor="' + inicial + '"]');
        if (objetivo) {
          group.querySelectorAll('.mt-producto__pill').forEach(function (p) { p.classList.remove('is-activa'); });
          objetivo.classList.add('is-activa');
        }
      });
    }
    actualizar();
  });
}

function formatoDinero(centavos) {
  var valor = (centavos / 100).toFixed(2).replace('.', ',');
  return valor + ' €';
}

function initCantidadProducto() {
  document.querySelectorAll('.mt-producto__cantidad').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var menos = wrap.querySelector('[data-accion="menos"]');
    var mas = wrap.querySelector('[data-accion="mas"]');
    if (!input) return;
    if (menos) menos.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    if (mas) mas.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });
}
